export default class User {
  socialid = null
  provider = null
  avatar = null
  email = null
  name = null
  surname = null
  gender = null
  location = null
  rounds = []

  constructor ({ socialid, provider, avatar, email, name, surname, gender, location, rounds }) {
    this.socialid = socialid || null
    this.provider = provider || null
    this.avatar = avatar || null
    this.optIn = false
    this.email = email || null
    this.name = name || null
    this.surname = surname || null
    this.gender = gender || null
    this.location = location || null
    this.rounds = rounds || []
  }
}
